export const imageClasses = 'absolute left-0 top-0 h-full w-full object-cover';
/**
 * magic 14%, 16% padding gets the image close to its requested size and keeps the image responsive while resizing
 */
export const imageWrapperClasses = 'relative h-0 pt-[16%] sm:pt-[14%]';
export const containerClasses = 'relative m-auto w-full';

export const sponsoredAfterClasses = "after:absolute after:right-2 after:mt-1 after:text-xs after:text-tertiary after:content-['Sponsored']";
